"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PULL_PANEL_TRANSITION_DURATION = void 0;
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var phy_touch_1 = tslib_1.__importDefault(require("phy-touch"));
var css3transform_1 = tslib_1.__importDefault(require("css3transform"));
var keepDom_1 = require("../../utils/keepDom");
var helper_1 = require("../../utils/helper");
var theme_1 = require("../../utils/theme");
var preventScrollPenetrate_1 = require("../../utils/preventScrollPenetrate");
var docs_user_agent_1 = tslib_1.__importDefault(require("@tencent/docs-user-agent"));
exports.PULL_PANEL_TRANSITION_DURATION = 300;
var TRIGGER_HIDE_TRANSLATE = 50;
var PullPanel = (function (_super) {
    tslib_1.__extends(PullPanel, _super);
    function PullPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.panelRef = React.createRef();
        _this.headerRef = React.createRef();
        _this.maskRef = React.createRef();
        _this.contentRef = React.createRef();
        _this.inShowAnimation = false;
        _this.handleClickMask = function () {
            !_this.inShowAnimation && _this.requestHide();
        };
        _this.handleMoveStop = function () {
            var _a = _this.props, visible = _a.visible, pullable = _a.pullable;
            if (!visible || !pullable || !_this.touch) {
                return;
            }
            if (_this.currentValue > TRIGGER_HIDE_TRANSLATE) {
                _this.requestHide();
            }
            else {
                _this.show();
            }
        };
        _this.preventDefault = function (e) {
            e.preventDefault();
        };
        _this.handleOrientationChange = function () {
            var handler = function () {
                var _a = _this.heights, PANEL_FULL_HEIGHT = _a.PANEL_FULL_HEIGHT, HALF_HEIGHT_TRANSLATE = _a.HALF_HEIGHT_TRANSLATE;
                var _b = _this.props, pullable = _b.pullable, visible = _b.visible;
                if (_this.touch) {
                    _this.touch.max = PANEL_FULL_HEIGHT;
                }
                if (visible) {
                    _this.currentValue = pullable ? 0 : HALF_HEIGHT_TRANSLATE;
                }
                _this.forceUpdate();
            };
            if (docs_user_agent_1.default.isIOS) {
                setTimeout(handler, 0);
            }
            else {
                handler();
            }
        };
        _this.themedRender = function (classNames) {
            var _a, _b, _c, _d, _e, _f;
            var _g = _this.props, prefixCls = _g.prefixCls, className = _g.className, style = _g.style, children = _g.children, visible = _g.visible, pullable = _g.pullable, destroyOnClose = _g.destroyOnClose, containerStyle = _g.containerStyle, okText = _g.okText, onOk = _g.onOk, title = _g.title, headerStyle = _g.headerStyle, contentStyle = _g.contentStyle, zIndex = _g.zIndex, cancelText = _g.cancelText, onCancel = _g.onCancel, header = _g.header, description = _g.description, showHeaderBorder = _g.showHeaderBorder, headerSize = _g.headerSize, headerClassName = _g.headerClassName, containerClassName = _g.containerClassName, contentClassName = _g.contentClassName;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-pullable"] = pullable,
                _a));
            var maskClasses = classNames(prefixCls + "-mask", (_b = {},
                _b[prefixCls + "-mask-hidden"] = !pullable || !visible,
                _b));
            var containerClasses = classNames(prefixCls + "-container", containerClassName, (_c = {},
                _c[prefixCls + "-container-hidden"] = !visible,
                _c));
            var headerPostfix = description ? 'with-desc' : headerSize;
            var headerClasses = classNames(prefixCls + "-header", prefixCls + "-header-" + headerPostfix, headerClassName, (_d = {},
                _d[prefixCls + "-header-show-border"] = showHeaderBorder,
                _d));
            var titleClassName = classNames(prefixCls + "-header-title", (_e = {},
                _e[prefixCls + "-header-title-with-desc"] = description,
                _e));
            var renderedChildren = children;
            if (destroyOnClose && !keepDom_1.decideKeepDom.call(_this, exports.PULL_PANEL_TRANSITION_DURATION, visible)) {
                renderedChildren = null;
            }
            return react_dom_1.default.createPortal(h("div", { className: containerClasses, style: tslib_1.__assign({ zIndex: zIndex }, containerStyle) },
                h("div", { className: maskClasses, onClick: _this.handleClickMask, ref: _this.maskRef }),
                h("div", { className: classes, style: tslib_1.__assign((_f = {}, _f[pullable ? 'maxHeight' : 'height'] = _this.heights.PANEL_FULL_HEIGHT + "px", _f), style), ref: _this.panelRef },
                    h("div", { className: headerClasses, ref: _this.headerRef, style: headerStyle }, header ?
                        header
                        : h(React.Fragment, null,
                            cancelText && h("span", { className: classNames(prefixCls + "-header-cancel"), onClick: onCancel }, cancelText),
                            h("span", { className: titleClassName },
                                h("span", null, title),
                                description && h("span", { className: classNames(prefixCls + "-header-desc") }, description)),
                            okText && h("span", { className: classNames(prefixCls + "-header-ok"), onClick: onOk }, okText))),
                    h("div", { className: classNames(prefixCls + "-content", contentClassName), style: tslib_1.__assign({ maxHeight: (pullable ? _this.heights.CONTENT_FULL_HEIGHT : _this.heights.CONTENT_HALF_HEIGHT) + "px" }, contentStyle), ref: _this.contentRef }, renderedChildren))), document.body);
        };
        return _this;
    }
    Object.defineProperty(PullPanel.prototype, "currentValue", {
        get: function () {
            var touch = this.touch;
            return touch.target[touch.property];
        },
        set: function (value) {
            var touch = this.touch;
            touch.target[touch.property] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PullPanel.prototype, "heights", {
        get: function () {
            var isLandscape = window.innerWidth > window.innerHeight;
            var PANEL_FULL_HEIGHT = window.innerHeight - 24;
            var PANEL_HALF_HEIGHT = isLandscape ?
                Math.min(PANEL_FULL_HEIGHT - 60, 300)
                : (window.innerHeight > 568 ? 375 : 300);
            var HALF_HEIGHT_TRANSLATE = PANEL_FULL_HEIGHT - PANEL_HALF_HEIGHT;
            var headerDom = this.headerRef.current;
            var HEADER_HEIGHT = headerDom ? headerDom.clientHeight : (this.props.pullable ? 72 : 56);
            var CONTENT_HALF_HEIGHT = PANEL_HALF_HEIGHT - HEADER_HEIGHT;
            var CONTENT_FULL_HEIGHT = PANEL_FULL_HEIGHT - HEADER_HEIGHT;
            return {
                PANEL_HALF_HEIGHT: PANEL_HALF_HEIGHT,
                PANEL_FULL_HEIGHT: PANEL_FULL_HEIGHT,
                HALF_HEIGHT_TRANSLATE: HALF_HEIGHT_TRANSLATE,
                HEADER_HEIGHT: HEADER_HEIGHT,
                CONTENT_HALF_HEIGHT: CONTENT_HALF_HEIGHT,
                CONTENT_FULL_HEIGHT: CONTENT_FULL_HEIGHT,
            };
        },
        enumerable: false,
        configurable: true
    });
    PullPanel.prototype.moveTo = function (destination, callback, needAnimation) {
        if (needAnimation === void 0) { needAnimation = true; }
        var touch = this.touch;
        touch.stop();
        touch._preventMove = true;
        touch.to(destination, needAnimation ? exports.PULL_PANEL_TRANSITION_DURATION : 0, undefined, function () {
            touch._preventMove = false;
            callback && callback();
        });
    };
    PullPanel.prototype.hide = function (callback) {
        var panelDom = this.panelRef.current;
        if (!panelDom) {
            return;
        }
        this.moveTo(panelDom.clientHeight, callback);
    };
    PullPanel.prototype.show = function (callback, needAnimation) {
        var _this = this;
        if (needAnimation === void 0) { needAnimation = true; }
        var pullable = this.props.pullable;
        var HALF_HEIGHT_TRANSLATE = this.heights.HALF_HEIGHT_TRANSLATE;
        this.inShowAnimation = true;
        this.moveTo(pullable ? 0 : HALF_HEIGHT_TRANSLATE, function () {
            _this.inShowAnimation = false;
            callback && callback();
        }, needAnimation);
    };
    PullPanel.prototype.requestHide = function () {
        (this.props.onCancel || this.props.onOk)();
    };
    PullPanel.prototype.componentDidMount = function () {
        var _this = this;
        var panelDom = this.panelRef.current;
        css3transform_1.default(panelDom);
        this.maskRef.current.addEventListener('touchmove', this.preventDefault);
        window.addEventListener('resize', this.handleOrientationChange);
        var _a = this.props, visible = _a.visible, pullable = _a.pullable, animateOnMount = _a.animateOnMount;
        this.touch = new phy_touch_1.default({
            touch: this.panelRef.current,
            target: panelDom,
            property: 'translateY',
            max: this.heights.PANEL_FULL_HEIGHT,
            min: 0,
            value: panelDom.clientHeight,
            touchEnd: this.handleMoveStop,
            touchCancel: this.handleMoveStop,
            animationEnd: this.handleMoveStop,
            fixed: !pullable,
            shouldRebound: function () { return _this.props.visible; },
            bindSelf: true,
        });
        if (visible) {
            this.show(undefined, animateOnMount);
        }
        preventScrollPenetrate_1.preventSelfScrollPenetrate(this.contentRef.current, 'y', 'upper');
    };
    PullPanel.prototype.componentWillUnmount = function () {
        this.maskRef.current.removeEventListener('touchmove', this.preventDefault);
        window.removeEventListener('resize', this.handleOrientationChange);
        this.touch = null;
    };
    PullPanel.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.visible && !this.props.visible) {
            return this.hide(function () {
                _this.touch && (_this.touch._preventMove = true);
            });
        }
        if (!prevProps.visible && this.props.visible) {
            return this.show(function () {
                _this.touch._preventMove = false;
            });
        }
    };
    PullPanel.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return PullPanel;
}(React.Component));
exports.default = PullPanel;
PullPanel.defaultProps = {
    prefixCls: 'dui-m-pullpanel',
    title: '标题',
    okText: '完成',
    cancelText: '',
    onOk: helper_1.emptyFn,
    destroyOnClose: false,
    pullable: true,
    animateOnMount: true,
    showHeaderBorder: true,
    headerSize: 'big',
};
PullPanel.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    containerStyle: PropTypes.object,
    destroyOnClose: PropTypes.bool,
    okText: PropTypes.node,
    cancelText: PropTypes.node,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    title: PropTypes.node,
    visible: PropTypes.bool,
    headerStyle: PropTypes.object,
    contentStyle: PropTypes.object,
    pullable: PropTypes.bool,
    zIndex: PropTypes.number,
    header: PropTypes.node,
    animateOnMount: PropTypes.bool,
    description: PropTypes.node,
    showHeaderBorder: PropTypes.bool,
    headerSize: PropTypes.oneOf(['small', 'big']),
    containerClassName: PropTypes.string,
    headerClassName: PropTypes.string,
    contentClassName: PropTypes.string,
};
